import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    constructor(private authService: AuthService) {}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const headers: { [name: string]: string } = {
            'Content-Type': 'application/json; charset=utf-8',
            'Accept': 'application/json'
        };

        const token = this.authService.getToken();
        const hasAuthorizationHeader = req.headers.has('Authorization');

        // Preserve per-request Authorization if caller already provided one.
        if (token && !hasAuthorizationHeader) {
            headers['Authorization'] = `Bearer ${token}`;
        }

        const secureReq = req.clone({ setHeaders: headers });
        return next.handle(secureReq);
    }
}